import { useState, useEffect } from 'react'
import { HiStatusOffline, HiStatusOnline } from 'react-icons/hi'
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr, FaDiscord, FaGlobeAmericas } from 'react-icons/fa'
import { HiChatAlt2 } from 'react-icons/hi'
import { IoMdChatboxes } from 'react-icons/io'

import SocialBtn from '../../components/buttons/SocialBtn'
import './home.css'
import UserAppContext from '../../hook/UserAppContext'

const Home = ({isHome}) => {

    const {user, data} = UserAppContext()
    const id_user = user.user.infordata.data || user.user.infordata.id_xat === '' ? 0 : user.user.infordata.id_xat 
    const [online, setOnline] = useState([])

    async function getOnline (id){
      try{
        const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
        const result = await response.json()
        setOnline(result)
      }catch(err){
        console.log('Error: ', err)
      }
    }

    useEffect(() => {
      getOnline(id_user)
    }, [id_user])

    if(!isHome) return 

    const {infordata, banners, social} = user.user 

    const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
    const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar 
    const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status 
    const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat 
    const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about 
    const banner = banners.data ? data.banner.image : banners[0].image 
    const banner_title = banners.data ? data.banner.title : banners[0].title

    return (
        <div className={isHome ? "page_content show home" : "page_content"}>
              <div className="banner">
                <img src={banner} alt={banner_title} />
              </div>
              <div className="wrapper_user">
                <div className="online_box">
                  <div className={online.status === "online" ? "online green" : "online red"}>
                    {online.status === "online" ? <HiStatusOnline/> : <HiStatusOffline/>}
                  </div>
                  <span>{online.status === "online" ? "Online Now" : "Offline"}</span>
                </div>
                <div className="user_data">
                  <div className="user_data__avatar">
                    <img src={avatar} alt={name} />
                  </div>
                  <div className="user_data__info">
                    <h1>{name}</h1>
                    <p>{status}</p>
                    <strong>{id_xat}</strong>
                  </div>
                  
                  <div className="user_data_descrition">
                    <p>{about}</p>
                  </div>

                  <div className="user_page">
                    <a href={infordata.data || infordata.homepage === '' ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer"><FaGlobeAmericas/></a>
                    <a href={infordata.data || infordata.xat_room === '' ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer"><HiChatAlt2/></a>
                    <a href={infordata.data || infordata.forum === '' ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer"><IoMdChatboxes/></a>
                  </div>
                </div>

                <div className="social">
                  <div className="social_menu">
                    <SocialBtn link={social.data || social.facebook === '' ? data.social.facebook : social.facebook} icon={<FaFacebookF/>}/>
                    <SocialBtn link={social.data || social.twitter === '' ? data.social.twitter : social.twitter} icon={<FaTwitter/>}/>
                    <SocialBtn link={social.data || social.instagram === '' ? data.social.instagram : social.instagram} icon={<FaInstagram/>}/>
                    <SocialBtn link={social.data || social.youtube === '' ? data.social.youtube : social.youtube} icon={<FaYoutube/>}/>
                    <SocialBtn link={social.data || social.tiktok === '' ? data.social.tiktok : social.tiktok} icon={<FaTiktok/>}/>
                    <SocialBtn link={social.data || social.tumblr === '' ? data.social.tumblr : social.tumblr} icon={<FaTumblr/>}/>
                    <SocialBtn link={social.data || social.discord === '' ? data.social.discord : social.discord} icon={<FaDiscord/>}/>
                  </div>
                </div>
              </div>
        </div>
    )
}

export default Home
